import { addLocale } from 'primereact/api';
import React from 'react';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { Button, Calendar } from '../prime';
import { IControlProps, MapProps } from './';
import styles from './calendar.module.scss';

const locale = {
  firstDayOfWeek: 1,
  dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
  dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
  monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
  monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  today: 'Hoy',
  clear: 'Limpiar',
  dateFormat: 'dd/mm/yy',
  weekHeader: 'Sm'
};

interface IProps extends IControlProps<Date> { 
  storage?: IDataStorage;
  /** Indica si se muestra el botón "Clear" */
  allowClear?: boolean;

  /** Fecha minima elegible */
  minDate?: Date;
  /** Fecha máxima elegible */
  maxDate?: Date;

  /** Calendario completo */
  inline?: boolean;

  /** Class personalizada para el Input */
  inputClassName?: string;
  /** Estilo personalizado para el Input */
  inputStyle?: React.CSSProperties;
  /** Class personalizada para el Panel de seleccion de fecha */
  panelClassName?: string;
  /** Estilo personalizado para el Panel de seleccion de fecha */
  panelStyle?: React.CSSProperties;

  /** Indica si se muestra la selección de Horario */
  showTime?: boolean;
  /** Indica si en la seleccion horaria se incluyen los segundos */
  showSeconds?: boolean;
}

interface IState extends IControlProps<Date> {
  storage?: IDataStorage;

  allowClear?: boolean;
  minDate?: Date;
  maxDate?: Date;
  inline?: boolean;
  inputClassName?: string;
  inputStyle?: React.CSSProperties;
  panelClassName?: string;
  panelStyle?: React.CSSProperties;
  showTime?: boolean;
  showSeconds?: boolean;

  /** Indica el mensaje de error si es que existe */
  validError?: string;
}

class Index extends React.Component<IProps, IState> {

  constructor(p:IProps) {
    super(p);
    addLocale('es', locale);
  }

  componentDidMount = () => {
    Index.getDerivedStateFromProps(this.props, this.state);
    if (this.props?.form && this.props?.name) this.props.form.add(this, this.props.name, () => this.change(this.state.value));
  }
  static getDerivedStateFromProps = (p: IProps, s?: IState) : IState => {
    let res : IState = { };
    if (p?.storage !== s?.storage) res.storage = p.storage;
    if (p?.allowClear !== s?.allowClear) res.allowClear = p.allowClear;
    if (p?.minDate !== s?.minDate) res.minDate = p.minDate;
    if (p?.maxDate !== s?.maxDate) res.maxDate = p.maxDate;
    if (p?.inline !== s?.inline) res.inline = p.inline;
    if (p?.inputClassName !== s?.inputClassName) res.inputClassName = p.inputClassName;
    if (p?.inputStyle !== s?.inputStyle) res.inputStyle = p.inputStyle;
    if (p?.panelClassName !== s?.panelClassName) res.panelClassName = p.panelClassName;
    if (p?.panelStyle !== s?.panelStyle) res.panelStyle = p.panelStyle;
    if (p?.showTime !== s?.showTime) res.showTime = p.showTime;
    if (p?.showSeconds !== s?.showSeconds) res.showSeconds = p.showSeconds;
    return MapProps(res, p, s);
  }

  render() {
    const { validError } = this.state;
    return (
      <div className={`form-group ${this.state.className ?? ''}`} style={this.state.style}>
        {this.state.title && <label className={(validError && styles.errortitle) ?? ''}>{this.state.title}</label>}
        <div className={`${styles.addons} p-inputgroup`}>
          {this.state.icon &&
            <span className={`p-inputgroup-addon`}>
              <i className={this.state.icon} />
            </span>
          }
          {this.state.required && 
            <span className={`p-inputgroup-addon ${(validError && styles.erroraddon) ?? ''}`}>
              <i className="pi pi-exclamation-circle" />
            </span>
          }
          
          <Calendar
            dateFormat="dd/mm/yy"
            locale="es"
            showButtonBar
            showIcon
            className={`${styles.calendar} ${validError && 'p-error'} ${this.state.className}`}
            style={this.state.style}
            inline={this.state.inline}

            selectOtherMonths
            
            inputClassName={`${styles.calendarInput} ${this.state.inputClassName}`}
            inputStyle={this.state.inputStyle}
            panelClassName={this.state.panelClassName}
            panelStyle={this.state.panelStyle}
            placeholder={this.state.placeholder} 
            disabled={this.state.disabled}

            value={this.state.value}
            minDate={this.state.minDate}
            maxDate={this.state.maxDate}
            showTime={this.state.showTime}
            showSeconds={this.state.showSeconds}
            
            tooltip={validError}
            tooltipOptions={{ position: 'bottom' }}
            
            onSelect={(e) => !this.state.disabled && this.change(e.value as Date)}
            onClearButtonClick={() => !this.state.disabled && this.change(undefined)}
            //onBlur={() => !this.state.disabled && this.change(this.state.value)}
          />
          {this.state.allowClear && <Button icon="pi pi-times" className="p-button-warning" onClick={(e) => { e.preventDefault(); this.change(undefined); }} />}
        </div>
        {validError && <span className={styles.errordesc}>{validError}</span>}
      </div>
    );
  }
  
  change = (value?: Date) => {
    const { onChange, validate, isValid } = this.props;

    let error = this.validate(value);
    if (!error && validate) error = validate(value);
    if (isValid) isValid(!error, error);
    
    this.setState({ validError: error, value });

    if (onChange) onChange(value, error);

    return error;
  };
  
  validate = (value?: Date) : string | undefined => {
    const { required } = this.props;

    if (required && !value) return 'campo requerido';

    return undefined;
  }
}

export default connect((s:any) => ({ storage:s.main }))(Index);
